import { MouseEvent } from 'react';

import * as S from './layout';

interface Props {
  label: string;
  handleClick?: (e: MouseEvent) => void;
}

const MyProductsFocusButton = (props: Props) => (
  <S.FocusButtonContainer onClick={props.handleClick}>
    <label>{props.label}</label>
  </S.FocusButtonContainer>
);

export default MyProductsFocusButton;
